import { toastr } from "react-redux-toastr";
import { reset } from "redux-form";
import axios from "axios";

import {
  TRANSPORT,
  SETSTATE,
  SELECT,
  DESELECT,
  RESET_SELECTION,
} from "./types";

export const stateSet = (data) => async (dispatch) => {
  try {
    dispatch({ type: SETSTATE, payload: data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
export const transport = (transporter) => async (dispatch) => {
  try {
    dispatch({ type: TRANSPORT, payload: { transporter: transporter } });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
export const resetForm = (value) => async (dispatch) => {
  try {
    dispatch(reset(value)); //value is the name of form
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//fetch AppParameter
export const fetchAppParameter = () => async (dispatch) => {
  try {
    const res = await axios.get(`/api/AppParameter`);
    dispatch({ type: TRANSPORT, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

export const select = (id) => async (dispatch) => {
  try {
    dispatch({ type: SELECT, payload: id });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// deselect

export const deselect = (id) => async (dispatch) => {
  try {
    dispatch({ type: DESELECT, payload: id });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// RESET SELECTION
export const resetSelections = () => async (dispatch) => {
  dispatch({ type: RESET_SELECTION });
};
